module.exports = __webpack_public_path__ + "static/img/TBOEM_OnlineTrailer_PointyRev_Prores_1080p-01.4c5c831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p-01.jpg
// module id = 196
// module chunks = 0